import Axios, { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';
import { User } from '../types/user';
import { refreshToken } from '../helpers/auth';

interface AxiosOptions extends AxiosRequestConfig {
  isAuthenticated?: boolean;
  headers?: any;
}

const { REACT_APP_BASE_URL: baseURL, REACT_APP_API_VERSION: apiVersion } = process.env;

const api = Axios.create({
  baseURL: baseURL! + apiVersion!,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor
api.interceptors.request.use(
  function (config: InternalAxiosRequestConfig<AxiosOptions>) {
    // Do something before request is sent
    const user: User = JSON.parse(Cookies.get('user') || '{}');
    if (user.auth_token) {
      config.headers['Authorization'] = `Bearer ${user.auth_token}`;
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  function (response) {
    if (response.data?.data) return response.data;
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      refreshToken();
    }
    return Promise.reject(error?.response?.data);
  },
);

export default api;
